<template>

    <div v-if="data" class="agri-note">


        <div class="agri-note-block">

            <div class="agri-notebook-shadow">
                <div :class="'agri-notebook ' + getBookColor" @click="openBook">

                    <div class="notebook-text-block">
                        <div class="title" v-if="data.crop_period_name">
                            {{ data.crop_period_name.slice(0,4) }}
                            <span v-if="data.crop_period_name.length > 4">...</span>
                        </div>
                        <div class="title" v-else>
                            Agri Note
                        </div>
                        <div class="text">
                            {{ getDateFromNow }}
                            <!-- {{ $tools.date.dateFormat( data.last_opt_time, 'YYYY-MM-DD' ) }} -->
                        </div>
                    </div>
                    <div class="notebook-rope"></div>
                
                </div>
            </div>

            <div v-if="showCreateButton" class="btn-create-note" @click="createRecord">
                <i class="fa fa-plus-circle"></i>新增紀錄
            </div>

        </div>


        <div class="agri-note-info">
            <h4 class="agri-note-info-title">{{ data.crop_period_name }}</h4>
            <div class="agri-note-info-body">
                <div>
                    <b-badge :variant="$tools.style.variantStatusButton('cropperiod', data.crop_period_status, false)">
                        {{ $t('status.cropperiod.' + data.crop_period_status) }}
                    </b-badge>
                </div>
                <div>
                    <i class="fa fa-pencil-square"></i>
                    <!-- {{ $t('menu.data_count') }}： -->
                    {{ data.record_count }}
                </div>
                <div v-if="data.last_opt_time">
                    <i class="fa fa-refresh"></i>
                    <!-- {{ $t('menu.updated') }}: -->
                    {{ $tools.date.dateFormat( data.last_opt_time, 'YYYY-MM-DD HH:mm' ) }}
                    <!-- <br>{{ getDateFromNow }} -->
                </div>
            </div>
        </div>

        

        
    </div>
    
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        bookColor: {
            type: String,
        },
        showCreateButton: {
            type: Boolean,
            default: true,
        },
        showNoRecordColor: {
            type: Boolean,
            default: true,
        },
    },
    data () {
        return {

        }
    },
    mounted () {

    },
    computed: {

        getDateFromNow ()
        {
            let _FromNow = this.$tools.date.getTimeFromNow( this.data.last_opt_time, false, this.data.project_timezone )
            return _FromNow[0] + ' ' + this.$t( _FromNow[1] )
        },

        getBookColor ()
        {
            // 有指定顏色就依照指定上色
            if ( this.bookColor != undefined )
            {
                return this.bookColor + '-book'
            }

            // 無資料就顯示預設的灰色
            if ( this.data == undefined || this.data == {} )
            {
                return 'default'
            }
            
            // 沒指定顏色就先判斷：沒有紀錄 = 淺灰，有紀錄就根據期作狀態上色
            let _color = 'green'
            if ( this.data.record_count == 0 && this.showNoRecordColor )
            {
                _color = 'gray'
            }
            else if ( this.data.crop_period_status )
            {
                switch ( this.data.crop_period_status )
                {
                    case 'farming': _color = 'green';   break;
                    case 'abandon': _color = 'dark';    break;
                    case 'done':    _color = 'yellow';  break;
                    default:        _color = 'default'; break;
                }
            }
            return _color + '-book'
        },
    },
    methods: {

        openBook ()
        {
            this.$router.push({ name: 'AgriDiary Detail', params: { cropperiodID: this.data.crop_period_id } })
        },

        createRecord ()
        {
            // this.$router.push(...)
        },
    },
}
</script>

<style lang="scss" scoped>

.agri-note
{
    margin: 10px;
    padding: 10px;
}

.agri-note-block
{
    display: inline-block;
    // margin: 0px 10px;
    text-align: center;

    width: 50%;
}
.agri-note-info
{
    display: inline-block;
    vertical-align: top;
    // margin: 0px 10px;
    text-align: center;

    width: 50%;
}


$book-width: 100px;
$book-height: 130px;

.dark-book
{
    background-image: linear-gradient( to bottom, #262f2f, #343030 ) !important;
    .title { color: #ffffff !important; }
    .text  { color: #bab9ac !important; }
    .notebook-rope { background-image: linear-gradient( to bottom, #6bc799, #186d7a ) !important; }
}
.blue-book
{
    background-image: linear-gradient( to bottom, #29a0e9, #144169 ) !important;
    .title { color: #ffffff !important; }
    .text  { color: #a1e9e8 !important; }
    .notebook-rope { background-image: linear-gradient( to bottom, #e1e7e4, #858786 ) !important; }
}
.yellow-book
{
    background-image: linear-gradient( to bottom, #ebc443, #bb691c ) !important;
    .title { color: #601b1b !important; }
    .text  { color: #674214 !important; }
    .notebook-rope { background-image: linear-gradient( to bottom, #64ab88, #244a40 ) !important; }
}
.brown-book
{
    background-image: linear-gradient( to bottom, #8e6b29, #422410 ) !important;
    .title { color: #ffffff !important; }
    .text  { color: #dfb987 !important; }
    .notebook-rope { background-image: linear-gradient( to bottom, #eeca3c, #cc7236 ) !important; }
}
.green-book
{
    background-image: linear-gradient( to bottom, #26906e, #0a4e46 ) !important;
    .title { color: #ffffff !important; }
    .text  { color: #a8dab4 !important; }
    .notebook-rope { background-image: linear-gradient( to bottom, #eeca3c, #cc7236 ) !important; }
}
.pink-book
{
    background-image: linear-gradient( to bottom, #c26584, #82264d ) !important;
    .title { color: #ffffff !important; }
    .text  { color: #f3cae7 !important; }
    .notebook-rope { background-image: linear-gradient( to bottom, #eeca3c, #cc7236 ) !important; }
}
.purple-book
{
    background-image: linear-gradient( to bottom, #855ebf, #45214a ) !important;
    .title { color: #ffffff !important; }
    .text  { color: #d6b5cc !important; }
    .notebook-rope { background-image: linear-gradient( to bottom, #9cc8d5, #233ea2 ) !important; }
}
.gray-book
{
    background-image: linear-gradient( to bottom, #a8aeb1, #61666c ) !important;
    .title { color: #050505 !important; }
    .text  { color: #4e4173 !important; }
    .notebook-rope { background-image: linear-gradient( to bottom, #bd6565, #652c3a ) !important; }
}

.agri-notebook
{
    display: inline-block;
    text-align: left;
    width: $book-width;
    height: $book-height;
    background-image: linear-gradient( to bottom, #767676, #949494 );
    border-radius: 2px 8px 8px 2px;
    // border: 1px solid #566465;
    border-bottom: 4px solid #acbbb2;  // 書本厚度

    &:hover
    {
        cursor: pointer;
        transform: scale(1.2);
    }

}
.agri-notebook-shadow
{
    display: inline-block;
    height: $book-height + 1px;
    border-radius: 2px 8px 8px 3px;
    border-bottom: 1px solid #566465;
}

.notebook-rope
{
    display: inline-block;
    position: relative;
    left: 83%;
    width: $book-width * 0.06;
    height: $book-height;
    background-image: linear-gradient( to bottom, #eeca3c, #cc7236 );
}

.notebook-text-block
{
    display: inline-block;
    position: absolute;
    margin-top: 20px;
    padding: 3px 10px;
    width: $book-width - 2px;
    background-color: rgba(255, 255, 255, 0.2);
    border-bottom: rgba(51, 155, 102, 0.3) 3px solid;
    
    .title
    {
        color: #222234;
        font-size: 0.9rem;
    }
    .text
    {
        color: #4e4173;
        font-size: 0.8rem;
    }
}

.agri-note-info-title
{
    text-align: left;
}
.agri-note-info-body
{
    text-align: left;
    font-size: 0.9rem;

    .badge
    {
        font-size: 0.9rem;
    }
}

.btn-create-note
{
    font-size: 0.9rem;
    i {
        vertical-align: middle;
        font-size: 1.6rem;
        color: #cc3643;
    }

    &:hover
    {
        cursor: pointer;
        transform: scale(1.2);
        color: #912c35;
    }
}


</style>